export const childReferralsInfo = [
  {
    title: "Male Children",
    percentage: 64,
    color: "#6C5DD3",
  },
  {
    title: "Female Children",
    percentage: 40,
    color: "#7FBA7A",
  },
];
